import React, { useState } from 'react';
import { Share2, Twitter, Facebook, Linkedin, Link as LinkIcon, Check } from 'lucide-react';

const SocialShare = ({ url, title, description }) => {
  const [copied, setCopied] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const shareUrl = url || window.location.href;
  const shareTitle = title || document.title;
  const shareText = description || '';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(shareTitle + ' ' + shareUrl)}`,
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-emerald-100 text-emerald-700 hover:bg-emerald-200 transition-colors"
      >
        <Share2 size={18} />
        <span className="text-sm font-medium">Share</span>
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 right-0 bg-white rounded-xl shadow-2xl border border-gray-200 p-4 z-50 min-w-[250px]">
          <p className="text-sm font-semibold text-gray-900 mb-3">Share this content</p>
          <div className="space-y-2">
            <a
              href={shareLinks.twitter}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-blue-50 transition-colors"
            >
              <Twitter className="text-blue-400" size={20} />
              <span className="text-sm text-gray-700">Twitter</span>
            </a>
            <a
              href={shareLinks.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-blue-50 transition-colors"
            >
              <Facebook className="text-blue-600" size={20} />
              <span className="text-sm text-gray-700">Facebook</span>
            </a>
            <a
              href={shareLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-blue-50 transition-colors"
            >
              <Linkedin className="text-blue-700" size={20} />
              <span className="text-sm text-gray-700">LinkedIn</span>
            </a>
            <button
              onClick={copyToClipboard}
              className="flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors w-full"
            >
              {copied ? (
                <>
                  <Check className="text-green-600" size={20} />
                  <span className="text-sm text-green-600">Copied!</span>
                </>
              ) : (
                <>
                  <LinkIcon className="text-gray-600" size={20} />
                  <span className="text-sm text-gray-700">Copy link</span>
                </>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialShare;
